import { render, staticRenderFns } from "./AgbPage.vue?vue&type=template&id=1596ddf8&scoped=true&"
import script from "./AgbPage.vue?vue&type=script&lang=js&"
export * from "./AgbPage.vue?vue&type=script&lang=js&"
import style0 from "./AgbPage.vue?vue&type=style&index=0&id=1596ddf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596ddf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VFlex,VLayout,VMain})
